import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Delete a user
 *
 * @private
 */
export const deleteUsers = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/user/delete', async (userIds: string[], thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/user/deleteUsers', {
      category: 'rpc',
      type: 'rpc/user/deleteUsers',
      userIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {deleteUsers}',
      { tags: ['rpc', 'user'], info: { error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Delete Users Failed',
      error,
    })
  }
})
